var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"horizontal-menu-arrow-right horizontal-menu-arrow-right-link",class:{ disabled: _vm.disabled },attrs:{"to":_vm.to,"event":_vm.disabled ? '' : 'click'}},[_c('icon-menu-arrow-right')],1)}
var staticRenderFns = []

export { render, staticRenderFns }